const keyboardKeys = {
  ENTER: 'Enter',
  ESC: 'Escape',
  ARROW_UP: 'ArrowUp',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  TAB: 'Tab',
  CAPS_LOCK: 'CapsLock',
  NUM_PAD_SUBTRACT: '-',
  DOT: '.'
};

export {
  keyboardKeys
};
